import React from 'react';
import { FaEnvelope, FaSpinner } from 'react-icons/fa';

export function InviteProxyModal({ 
  show, 
  inviteProxy, 
  inviteMessage, 
  setInviteMessage, 
  sendingInvite, 
  onSend, 
  onClose 
}) {
  if (!show || !inviteProxy) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center px-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6" data-testid="invite-proxy-modal">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-3 bg-green-100 rounded-full">
            <FaEnvelope className="text-green-600 text-xl" />
          </div>
          <h3 className="text-2xl font-bold text-gray-800">Invite to Join</h3>
        </div>
        
        <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-4">
          <p className="text-green-800">
            Send an invitation to <strong>{inviteProxy.name}</strong> to create their own free account.
          </p>
          <p className="text-sm text-green-700 mt-2">
            Once they create an account, they'll be able to:
          </p>
          <ul className="text-sm text-green-700 mt-1 list-disc list-inside">
            <li>Log in and access the family</li>
            <li>RSVP to events themselves</li>
            <li>Take on family roles with real permissions</li>
            <li>Participate in voting and chat</li>
          </ul>
        </div>
        
        <div className="mb-4">
          <p className="text-sm text-gray-600 mb-2">
            Sending to: <strong>{inviteProxy.email}</strong>
          </p>
        </div>
        
        <div className="mb-4">
          <label className="block text-gray-700 font-medium mb-2">
            Personal Message (optional)
          </label>
          <textarea
            value={inviteMessage}
            onChange={(e) => setInviteMessage(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-600 focus:border-transparent"
            rows="3"
            placeholder="Add a personal note to the invitation..."
            data-testid="invite-message-input"
          />
        </div>

        <div className="flex space-x-4">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={onSend}
            disabled={sendingInvite}
            className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 flex items-center justify-center space-x-2"
            data-testid="send-invite-btn"
          >
            {sendingInvite ? (
              <>
                <FaSpinner className="animate-spin" />
                <span>Creating Link...</span>
              </>
            ) : (
              <>
                <FaEnvelope />
                <span>Create & Send Invitation</span>
              </>
            )}
          </button>
        </div>
        <p className="text-xs text-center text-gray-500 mt-3">
          Note: If email delivery fails, the invitation link will be copied to your clipboard to share manually.
        </p>
      </div>
    </div>
  );
}
